import { makeStyles } from "@mui/styles";
import curved0 from "assets/images/curved-images/profile.jpeg";

export default makeStyles(({ palette, functions, borders, boxShadows }) => {
  const { white } = palette;
  const { rgba, pxToRem } = functions;
  const { borderRadius } = borders;
  const { navbarBoxShadow } = boxShadows;

  return {
    profileHeader_background: {
      backgroundImage: `url(${curved0})`,
      backgroundSize: "cover",
      backgroundPosition: "50%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      position: "relative",
      height: pxToRem(300),
      borderRadius: borderRadius.xl,
    },

    logoOverlay: {
      position: "absolute",
      top: "50%", // Centrado verticalmente
      left: "50%", // Centrado horizontalmente
      transform: "translate(-50%, -120%)", // Ajuste para mantener el logo centrado
      width: pxToRem(300), // Ajusta el tamaño del logo según prefieras
      height: "auto",
      zIndex: 2, // Asegúrate de que esté sobre el fondo
    },

    profileHeader_profile: {
      backdropFilter: `saturate(200%) blur(${pxToRem(30)})`,
      backgroundColor: rgba(white.main, 0.8),
      boxShadow: navbarBoxShadow,
      margin: `${pxToRem(-64)} ${pxToRem(24)} 0`,
      padding: pxToRem(16),
      position: "relative",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      minHeight: pxToRem(160),
      height: "100%",
    },

    profileImageContainer: {
      position: "relative",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: pxToRem(130),
      height: pxToRem(130),
      overflow: "hidden",
      borderRadius: borderRadius.lg,
      boxShadow: `0 4px 6px 0 rgba(0, 0, 0, 0.1)`,
    },

    editButton: {
      position: "absolute",
      top: pxToRem(6),
      left: pxToRem(6),
      backgroundColor: "rgba(255, 255, 255, 0.7)",
      borderRadius: "50%",
      padding: pxToRem(4),
    },

    deleteButton: {
      position: "absolute",
      top: pxToRem(6),
      right: pxToRem(6),
      backgroundColor: "rgba(255, 255, 255, 0.7)",
      borderRadius: "50%",
      padding: pxToRem(4),
    },

    avatarSize: {
      width: "100%",
      height: "100%",
      objectFit: "cover",
    },

    profileEditorContainer: {
      marginTop: pxToRem(15), // Ajusta este valor para alinear el texto con el borde inferior de la imagen
    },
  };
});
